export default __webpack_public_path__ + "static/media/medaille-qdo-or-conception.e27a9cfb.png";